module.exports = {
  ROLE_TYPE: {
    GLOBAL: 'GLOBAL',
    CUSTOM: 'CUSTOM'
  },
  ADMIN_ROLE: '1'
};
